<div class="page-container" [class.loading]="isLoading">
    <app-header [back]="true" [title]="'document.manageDocumentTags'"></app-header>
    <app-table [table]="table" (menuItemSelected)="menuAction($event)">
        <app-empty-state
            label="{{ 'document.noTagsExist' | translate }}"
            src="/assets/illustrations/empty-box.png"
        ></app-empty-state>
    </app-table>
</div>

<!-- Tag rename modal -->
<ui-dialog
    header="document.documentTag"
    size="small"
    [form]="documentTagForm?.form ? documentTagForm.form : undefined"
    (primaryButtonPressed)="documentTagForm.form.valid && onSaveDocumentTag(documentTagForm)"
    [open]="documentTagFormOpen"
    (closing)="documentTagFormOpen = false; table.reload()"
    (secondaryButtonPressed)="documentTagFormOpen = false; table.reload()"
    primaryButtonLabel="{{ 'save' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
>
    <app-document-tag-form #documentTagForm></app-document-tag-form>
</ui-dialog>

<!-- Tag delete modal -->
<ui-confirmation-dialog
    #confirmDeleteTagDialog
    header="{{ 'document.deleteTag' | translate: { tagName: tagNameToDelete } }}"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
>
    {{ 'document.areYouSureYouWantToDeleteTag' | translate: { tagName: tagNameToDelete } }}
</ui-confirmation-dialog>
